import { MRT_OrderedColumnDef } from "@/types/commonTypes";
import { useMemo } from "react";
import { MRT_RowData } from "material-react-table";


export const useOrderedColumns = <T extends MRT_RowData>(columns: MRT_OrderedColumnDef<T>[]) =>
  useMemo(() => columns.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)), [columns]);